export const SR_PROJECT_MANAGER_REVIEW_DATA = [
  {
    id: 1,
    title: "Enterprise Project Leadership & Ownership",
    definition: "Owns outcomes across projects and PMs, not just individual jobs.",
    questions: [
      "Acts as the ultimate owner of outcomes across all assigned projects and PMs.",
      "Sets clear standards and expectations for the PM team.",
      "Intervenes early when projects or PMs start to drift.",
      "Does not allow recurring problems to persist.",
      "Makes timely, high-quality decisions.",
      "Escalates issues appropriately and early.",
      "Holds PMs accountable to LIDA standards consistently.",
      "Is trusted by PMs, trades, clients, and leadership.",
      "Leads calmly under pressure.",
      "Is seen as the clear leader of the delivery organization."
    ]
  },
  {
    id: 2,
    title: "Portfolio Planning, Scheduling & Execution Control",
    definition: "Ensures predictable delivery across all projects.",
    questions: [
      "Ensures all projects have current, realistic schedules.",
      "Ensures PMs actively use schedules to drive execution.",
      "Reviews and challenges sequencing and critical paths.",
      "Prevents systemic schedule slippage across the portfolio.",
      "Ensures long‑lead items are planned and ordered.",
      "Drives recovery plans when any project falls behind.",
      "Keeps leadership informed of schedule risks.",
      "Rarely allows schedule surprises.",
      "Improves overall schedule reliability over time.",
      "Consistently delivers portfolio commitments."
    ]
  },
  {
    id: 3,
    title: "Portfolio Financial Stewardship & Margin Protection",
    definition: "Owns financial performance across the portfolio.",
    questions: [
      "Understands the financial health of every project.",
      "Ensures cost codes and WIP are current across projects.",
      "Does not allow budget issues to persist unaddressed.",
      "Challenges PMs on allowances, scope, and margin protection.",
      "Ensures invoice and cost control discipline.",
      "Prevents systemic margin erosion.",
      "Understands financial impact of schedule and quality issues.",
      "Protects company margin and cashflow.",
      "Communicates financial risks early.",
      "Delivers predictable financial outcomes."
    ]
  },
  {
    id: 4,
    title: "Portfolio Scope, Change & Risk Management",
    definition: "Prevents systemic risk through standards and discipline.",
    questions: [
      "Ensures PMs enforce scope and change control.",
      "Prevents undocumented or verbal changes.",
      "Ensures RFIs and documentation are disciplined.",
      "Reduces disputes through clear documentation.",
      "Ensures client decisions are driven and recorded.",
      "Improves documentation discipline company‑wide.",
      "Prevents small issues from becoming big ones.",
      "Protects LIDA contractually.",
      "Rarely sees disputes escalate.",
      "Continuously improves scope/change systems."
    ]
  },
  {
    id: 5,
    title: "Client Experience Standards & Escalation Leadership",
    definition: "Owns consistency of client experience across all projects.",
    questions: [
      "Ensures consistent client experience across all PMs.",
      "Prevents recurring communication failures.",
      "Reviews and improves client communication systems.",
      "Intervenes early in client risk situations.",
      "Builds a culture of proactive communication.",
      "Ensures Buildertrend and reporting standards are met.",
      "Reduces complaints and escalations.",
      "Improves satisfaction trends.",
      "Creates consistency in how LIDA shows up to clients.",
      "Builds referral and reputation momentum."
    ]
  },
  {
    id: 6,
    title: "Quality Systems & Technical Standards Leadership",
    definition: "Sets and enforces quality standards company‑wide.",
    questions: [
      "Sets the quality standard for all projects.",
      "Ensures PMs inspect proactively.",
      "Reduces systemic rework.",
      "Enforces site cleanliness and safety standards.",
      "Improves turnover quality.",
      "Builds quality systems, not heroics.",
      "Prevents repeated quality failures.",
      "Raises technical standards over time.",
      "Protects long‑term durability and reputation.",
      "Is known for raising the bar on quality."
    ]
  },
  {
    id: 7,
    title: "People Leadership, Coaching & Accountability",
    definition: "Builds PM capability and leadership bench.",
    questions: [
      "Develops strong PMs and future leaders.",
      "Coaches PMs effectively and consistently.",
      "Does not tolerate chronic underperformance.",
      "Builds accountability culture.",
      "Resolves people and trade conflicts quickly.",
      "Improves collaboration between PMs.",
      "Attracts and retains strong talent.",
      "Builds bench strength.",
      "Is seen as fair, firm, and supportive.",
      "Improves overall team performance year over year."
    ]
  },
  {
    id: 8,
    title: "Systems, Scorecards & Operating Discipline",
    definition: "Runs the organization through systems and metrics.",
    questions: [
      "Ensures PMs follow LIDA systems and SOPs.",
      "Does not allow systemic admin slippage.",
      "Uses scorecards and performance points to manage.",
      "Improves how systems are used in practice.",
      "Prevents workarounds and heroics.",
      "Ensures reporting is accurate and reliable.",
      "Builds discipline into execution.",
      "Improves management cadence.",
      "Uses data to drive decisions.",
      "Builds scalable operating systems."
    ]
  },
  {
    id: 9,
    title: "Culture, Leadership Growth & Company Building",
    definition: "Builds the company, not just the current workload.",
    questions: [
      "Lives and enforces LIDA core values.",
      "Builds leaders, not just projects.",
      "Is coachable and seeks feedback.",
      "Develops own leadership capability.",
      "Contributes to company strategy and improvement.",
      "Builds culture intentionally.",
      "Raises standards across the organization.",
      "Represents LIDA at leadership level.",
      "Invests in long‑term capability building.",
      "Leaves the organization stronger than they found it."
    ]
  },
  {
    id: 10,
    title: "Personal Project Execution (PM Standard)",
    definition: "Personally demonstrates the PM standard through their own projects.",
    questions: [
      "Personally runs assigned projects to full LIDA PM standard.",
      "Own projects meet schedule commitments.",
      "Own projects meet budget and margin expectations.",
      "Own projects maintain LIDA quality standards.",
      "Own admin and Buildertrend discipline meets PM standard.",
      "Leads own projects by example.",
      "Own projects do not require rescue or special treatment.",
      "PMs can point to these projects as the standard.",
      "Balances personal execution with portfolio leadership.",
      "Demonstrates hands‑on credibility with clients and in the field."
    ]
  }
];
